import * as firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";

var firebaseConfig = {
  apiKey: "AIzaSyAtTO4vC9DHRC2Sr6ePYahq8Dhmpyp70pY",
  authDomain: "niko-11132.firebaseapp.com",
  projectId: "niko-11132",
  storageBucket: "niko-11132.appspot.com",
  messagingSenderId: "947824826491",
  appId: "1:947824826491:web:ab0703a68675256fe32ade",
  measurementId: "G-715Z96S7VT",
};
firebase.initializeApp(firebaseConfig);

var db = firebase.firestore();
var storage = firebase.storage();

export { db, storage, firebase };
